// The payment banner inside a product (Accelerator.dc.html, its "Payment overdue" Tweak), in the
// product's own look, at the top of every open product page while a payment is overdue or suspended:
// - this product's own: the board's words, "Your payment didn't go through on 25 September.
//   Everything stays open until 2 October while you sort it.";
// - this product's own, on a place someone else's subscription pays for (a partner seat, billing/payer.js):
//   the payer's payment, "Marcus's payment for your membership didn't go through on 25 September.
//   Everything stays open until 2 October while they sort it.", with no Update card, since the card is
//   the payer's (undrawn: the Accelerator's move, 11 Oct);
// - another product's: the Library's words, which name it (design 5.3: a banner on every screen).
// 1 button, Update card, opening Stripe's card form for that product's billing (shell/PaymentBanner),
// unless the place is paid for by someone else.
import * as f from '../lib/format.js'
import { Link } from '../lib/router.jsx'
import { useUpdateCard } from '../shell/PaymentBanner.jsx'
import { paidByOther, payerPayment, payerSorts, placeWord } from '../billing/payer.js'

// This product's own overdue line, or null. product: for a place someone else pays for, what it is
export function ownOverdueLine(access, product) {
  if (!access || access.status !== 'overdue') return null
  const on = access.payment_failed_at ? ` on ${f.dayMonthLong(access.payment_failed_at)}` : ''
  const until = access.suspend_on ? ` until ${f.dayMonthLong(access.suspend_on)}` : ''
  if (paidByOther(access)) {
    return `${payerPayment(access, placeWord(product))} didn't go through${on}. Everything stays open${until} ${payerSorts(access)}.`
  }
  return `Your payment didn't go through${on}. Everything stays open${until} while you sort it.`
}

// { text, target } for the banner, or null. model: the Library's (banner, bannerFor); owned: this
// product's ownedProducts entry. target.paidByOther: no Update card
export function productBanner(model, owned) {
  const own = ownOverdueLine(owned?.access, owned?.product)
  if (own) {
    return {
      text: own,
      target: { productId: owned.product.id, hasCustomer: owned.rows.some(r => r.has_customer), paidByOther: paidByOther(owned.access) },
    }
  }
  if (model?.banner && model.bannerFor) return { text: model.banner, target: model.bannerFor }
  return null
}

export function ProductBanner({ banner }) {
  const card = useUpdateCard(banner?.target)
  if (!banner) return null
  return (
    <div className="pp-banner">
      <span className="pp-banner-text" role={card.message ? 'alert' : undefined}>
        {card.message || banner.text}
      </span>
      {!banner.target?.paidByOther && (
        <Link to="/account" className="pp-banner-btn" onClick={card.onClick} aria-busy={card.state === 'opening' || undefined}>Update card</Link>
      )}
    </div>
  )
}
